import ArgonBox from 'components/ArgonBox'
import React, { useEffect, useMemo, useState } from 'react'
import Tambah from './Tambah'
import { Card, CardContent, CardHeader } from '@mui/material'
import ArgonTypography from 'components/ArgonTypography'
import userStore from 'store/userStore'
import { CustomDescrypt } from 'global/func'
import Perencanaan from 'examples/Tables/TabelKodefikasi/Perencanaan'
import { postDataWithResponse } from 'global/postFunc'
import Swal from 'sweetalert2'
import { postDelete } from 'global/postFunc'
import Edit from './Edit'

const SumberPendanaan = () => {
    const { user, tahunAnggaran, addReq } = userStore(state => ({ user: state.user, tahunAnggaran: state.tahunAnggaran, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const [updating, setUpdating] = useState(false)

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50, //customize the default page size
    });
    // const [globalFilter, setGlobalFilter] = useState('')
    const [columnFilter, setColumnFilter] = useState([])

    const reqKodefikasi = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/sa/sumber-pendanaan/server-side',
            {
                pagination: pagination,
                columnFilter: columnFilter
            },
            decryptedUser,
            (res) => {
                console.log(res);
                setData(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqKodefikasi()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pagination,
        columnFilter,
        updating
    ])

    const columns = useMemo(() => ([
        {
            accessorKey: null,
            header: '#',
            size: 5,
            Cell: ({ cell }) => (
                <>
                    <ArgonTypography
                        fontSize="small"
                        variant="inherit"
                    >
                        {(pagination.pageIndex * pagination.pageSize) + cell.row.index + 1}
                    </ArgonTypography>
                </>
            )
        },
        {
            accessorKey: 'kode',
            header: 'Kode',
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontSize="small"
                    fontWeight={(cell.row.original.ket === 'SUMBER DANA' || cell.row.original.ket === 'KELOMPOK' || cell.row.original.ket === 'JENIS' || cell.row.original.ket === 'OBJEK' || cell.row.original.ket === 'RINCIAN OBJEK') && 'bold'}
                    variant="inherit"
                >
                    {cell.getValue()}
                </ArgonTypography>
            ),
        },
        {
            accessorKey: 'uraian',
            header: 'Uraian',
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontSize="small"
                    fontWeight={(cell.row.original.ket === 'SUMBER DANA' || cell.row.original.ket === 'KELOMPOK' || cell.row.original.ket === 'JENIS' || cell.row.original.ket === 'OBJEK' || cell.row.original.ket === 'RINCIAN OBJEK') && 'bold'}
                    variant="inherit"
                >
                    {cell.getValue()}
                </ArgonTypography>
            )
        },
        {
            accessorKey: 'ket',
            header: 'Ket',
            Cell: ({ cell }) => (
                <ArgonTypography
                    fontSize="small"
                    fontWeight={(cell.row.original.ket === 'SUMBER DANA' || cell.row.original.ket === 'KELOMPOK' || cell.row.original.ket === 'JENIS' || cell.row.original.ket === 'OBJEK' || cell.row.original.ket === 'RINCIAN OBJEK') && 'bold'}
                    variant="inherit"
                >
                    {cell.getValue()}
                </ArgonTypography>
            ),
            filterSelectOptions: [
                { label: 'AKUN', value: 'AKUN' },
                { label: 'KELOMPOK', value: 'KELOMPOK' },
                { label: 'JENIS', value: 'JENIS' },
                { label: 'OBJEK', value: 'OBJEK' },
                { label: 'RINCIAN OBJEK', value: 'RINCIAN OBJEK' },
                { label: 'SUB RINCIAN OBJEK', value: 'SUB RINCIAN OBJEK' },
            ],
            filterVariant: 'select',
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ]), [data, pagination])

    const columnVisibility = {
        // kinerja: false,
        // indikator: false,
        // satuan: false,
    }

    const [openEdit, setOpenEdit] = useState(false)
    const [editData, setEditData] = useState({})
    const handleOpenEdit = () => setOpenEdit(true);
    const handleCloseEdit = () => setOpenEdit(false);

    const deleteData = (kode, ket) => {
        Swal.fire({
            title: 'Hapus Data?' ,
            text: kode + " " + ket + " akan dihapus",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Hapus',
            cancelButtonText: 'Batal',
            confirmButtonColor: '#dd3333',
            // cancelButtonColor: '#d33',
        }).then((result) => {
            if (result.isConfirmed) {
                addReq()
                postDelete(
                    '/sa/sumber-pendanaan/delete',
                    {
                        _method: 'DELETE',
                        kode: kode,
                        ket: ket
                    },
                    decryptedUser,
                    setLoading,
                    () => { setUpdating(!updating) }
                )
            }
        })
    }

    return (
        <ArgonBox pt={3} pb={5}>
            <ArgonBox mb={3}>
                <Card>
                    <CardHeader
                        title={
                            <ArgonTypography variant='h6'>Tabel Kodefikasi Sumber Pendanaan</ArgonTypography>
                        }
                        action={
                            <Tambah
                                decryptedUser={decryptedUser}
                                updating={updating}
                                setUpdating={setUpdating}
                                addReq={addReq}
                                tahunAnggaran={tahunAnggaran}
                            />
                        }
                    />
                    <CardContent>
                        <ArgonBox mb={3}>
                            <Perencanaan
                                loading={loading}
                                data={data.data}
                                columns={columns}
                                rowCount={data.rowCount}
                                pagination={pagination}
                                setPagination={setPagination}
                                columnFilter={columnFilter}
                                setColumnFilter={setColumnFilter}
                                columnVisibility={columnVisibility}
                                setEditData={setEditData}
                                handleOpenEdit={handleOpenEdit}
                                deleteData={deleteData}
                            />
                        </ArgonBox>
                    </CardContent>
                </Card>
            </ArgonBox>

            <Edit
                decryptedUser={decryptedUser}
                editData={editData}
                open={openEdit}
                handleCloseDialog={handleCloseEdit}
                updating={updating}
                setUpdating={setUpdating}
                addReq={addReq}
            />
        </ArgonBox>
    )
}

export default SumberPendanaan